/**
 * Requires link to media file from gallery/image settings.
 *
 * Try to find the a-tag parents to the images (the img-tag itself with the last two selectors), both gutenberg and classic editor.
 * Selectors:
 *   gutenberg gallery,
 *   classic gallery,
 *   gutenberg images AND classic images with caption,
 *   classic images without caption and with no or center align,
 *   classic images without caption and with left or right align
 */
const lightboxesInContent = () => {
    var imgItems = document.querySelectorAll('.blocks-gallery-item > figure > a, .gallery-item > .gallery-icon > a, .wp-block-image a, p > a > img, p > a > .wp-block-image');
    // if found, add .lightbox class that Tobi uses as selector to the items
    if (imgItems.length) {
        for (let i = 0; i < imgItems.length; i++) {
            let item = imgItems[i];
            var formats = ['.jpg', '.png', '.jpeg', '.gif'];
            // check (3 first selectors) href to verify media link
            if (item.href) {
                for (let j = 0; j < formats.length; j++) {
                    if (item.href.includes(formats[j])) {
                        item.classList.add('contentsimplelightbox');
                    }
                }
                // check for figcaption (images and gutenberg gallery) and add it to a data attribute
                if (item.nextElementSibling) {
                    if (item.nextElementSibling.nodeName.toLowerCase() === 'figcaption') {
                        item.dataset.caption = item.nextElementSibling.innerText;
                    }
                } else if (item.parentNode.nextElementSibling) { // classic gallery
                    if (item.parentNode.nextElementSibling.nodeName.toLowerCase() === 'figcaption') {
                        item.dataset.caption = item.parentNode.nextElementSibling.innerText;
                    }
                }
            } else if (item.parentNode.href) { // check (2 last selectors) href to verify media link
                for (let j = 0; j < formats.length; j++) {
                    if (item.parentNode.href.includes(formats[j])) {
                        item.parentNode.classList.add('contentsimplelightbox');
                    }
                }
            }
        }
    }
};
lightboxesInContent();


let contentimage = new SimpleLightbox('.contentsimplelightbox', {
    uniqueImages: false,
    captionsData: 'alt',
    overlayOpacity: 0.9,
});

/*
defaultOptions = {
    sourceAttr: 'href',
    overlay: true,
    overlayOpacity: 0.7,
    spinner: true,
    nav: true,
    navText: ['&lsaquo;', '&rsaquo;'],
    captions: true,
    captionDelay: 0,
    captionSelector: 'img',
    captionType: 'attr',
    captionsData: 'title',
    captionPosition: 'bottom',
    captionClass: '',
    captionHTML: true,
    close: true,
    closeText: '&times;',
    swipeClose: true,
    showCounter: true,
    fileExt: 'png|jpg|jpeg|gif|webp|avif',
    animationSlide: true,
    animationSpeed: 250,
    preloading: true,
    enableKeyboard: true,
    loop: true,
    rel: false,
    docClose: true,
    swipeTolerance: 50,
    className: 'simple-lightbox',
    widthRatio: 0.8,
    heightRatio: 0.9,
    scaleImageToRatio: false,
    disableRightClick: false,
    disableScroll: true,
    alertError: true,
    alertErrorMessage: 'Image not found, next image will be loaded',
    additionalHtml: false,
    history: true,
    throttleInterval: 0,
    doubleTapZoom: 2,
    maxZoom: 10,
    htmlClass: 'has-lightbox',
    rtl: false,
    fixedClass: 'sl-fixed',
    fadeSpeed: 300,
    uniqueImages: true,
    focus: true,
    scrollZoom: true,
    scrollZoomFactor: 0.5,
    download: false
};
*/
